"use client";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { useSelector } from "react-redux";
import { ChangePasswordProps } from "@/interface/account";
import { useRouter } from "next/navigation";
import toast from "react-hot-toast";
import { AppState } from "@/store/configureStore";
import { CHANGE_PASSWORD_API } from "@/constants";

const useChangePassword = () => {
	const user = useSelector((state: AppState) => state.user);
	const router = useRouter();

	const changePasswordSchema = yup.object({
		old_password: yup
			.string()
			.required("Password is required")
			.min(8, "must be at least 8 characters long"),
		new_password: yup
			.string()
			.required("Password is required")
			.min(8, "must be at least 8 characters long"),
		confirm_password: yup
			.string()
			.required("Confirm your password")
			.oneOf([yup.ref("new_password")], "Passwords must match")
			.min(8, "must be at least 8 characters long"),
	});

	const {
		register,
		watch,
		handleSubmit,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(changePasswordSchema),
	});

	const handleChangePassword = async (data: ChangePasswordProps) => {
		// console.log(data);
		try {
			const response = await axios.put(
				CHANGE_PASSWORD_API,
				{
					userId: user?.id,
					oldPassword: data.old_password,
					newPassword: data.confirm_password,
				},
				{
					headers: {
						Authorization: `Bearer ${user?.token}`,
					},
				}
			);
			// console.log("API Response", response.data);
			toast.remove();
			toast.success(`Password successfully changed`);
			router.push("/login");
		} catch (error: any) {
			if (error?.response?.status === 400) {
				toast.remove();
				toast.error("The current password you entered is wrong");
			} else {
				toast.remove();
				toast.error(`Error: ${error.message || "Something went wrong"}`);
			}
			// console.log("API Error", error);
		}
	};

	return {
		register,
		watch,
		handleSubmit,
		errors,
		handleChangePassword,
	};
};
export default useChangePassword;
